/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * ROSC特定行為
 */
export type TreatmentROSCTreatmentsEnum =
  (typeof TreatmentROSCTreatmentsEnum)[keyof typeof TreatmentROSCTreatmentsEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TreatmentROSCTreatmentsEnum = {
  DC: 'DC',
  ADRENALINE_IV: 'ADRENALINE_IV',
  ADRENALINE_IM: 'ADRENALINE_IM',
  EPIPEN: 'EPIPEN',
  GLUCOSE: 'GLUCOSE',
} as const;
